import { displayText } from "../../locales/display";
import { useLocale } from "../../hooks/useLocale";
import { VBox } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";

export const statusColor = (s: string) => {
	switch (s?.toLowerCase()) {
		case "completed":
		case "success":
			return { bg: "rgba(22,163,74,0.10)", color: "#16A34A" };
		case "failed":
		case "error":
			return { bg: "rgba(220,38,38,0.10)", color: "#DC2626" };
		case "pending":
		case "started":
		case "3ds":
		case "pay":
		case "submitted":
		case "uploading":
		case "added":
			return { bg: "rgba(234,179,8,0.12)", color: "#B45309" };
		case "init":
		case "unknown":
			return { bg: "rgba(100,116,139,0.10)", color: "#64748B" };
		case "expired":
			return { bg: "rgba(124,58,237,0.10)", color: "#7C3AED" };
		default:
			return { bg: "transparent", color: "inherit" };
	}
};

export const statusBadgeSx = (s: string) => {
	const c = statusColor(s);
	return {
		whiteSpace: "nowrap",
		color: c.color,
		fontWeight: 600,
	} as const;
};

export const StatusBadge = ({ label, value }: { label?: string; value: string }) => {
 useLocale();
 return (
	<VBox gap="4px">
		{label && (
			<Typo sx={{ whiteSpace: "nowrap" }} variant="caption">
				{displayText(label)}
			</Typo>
		)}
		<Typo sx={statusBadgeSx(value)} variant="medium">
			{displayText(value)}
		</Typo>
	</VBox>
);
};
